<template>
  <div class="about">
    <div class="header">
      <img src="../../assets/kh-007ab.jpg" alt="banner" class="banner">
      <div class="nav">
        <img src="../../assets/logo.png" alt class="logo">
        <router-link to="/" class="back">
          <span>返回主菜单</span>
          <img src="../../assets/back.png" alt="back">
        </router-link>
      </div>
    </div>
    <div class="body">
      <div class="body_title">
        <span class="body_title_name">联系我们</span>
        <router-link to="/" class="contentus">合作优势>></router-link>
      </div>
    </div>
    <div class="main">
      <ul class="main_ul">
        <li>
          <h3 class="main_h3 active">样册索取</h3>
          <div class="get_book">
            <img src="../../assets/cont4.33a5d964.png" alt>
            <p>我们提供的样册中除了包含尺寸、形状、精度等级、齿距、硬度、是否研磨、容许扭矩等规格参数外，还附有齿轮技术参考书，在客户设计选型时发挥重要作用。</p>
            <div class="get_btn" @click="showModal = true">
              <span>产品样册索取</span>
              <span>Request Catalog</span>
            </div>
          </div>
        </li>
        <li>
          <h3 class="main_h3">通讯地址</h3>
          <div class="address">
            <!-- 地图容器，调用高德地图 -->
            <div class="map" id="container">
              <el-amap
                ref="map"
                vid="amapDemo"
                :plugin="plugin"
                :center="center"
                :zoom="zoom"
                class="amap-demo"
              >
                <el-amap-marker vid="component-marker" :position="componentMarker.position"></el-amap-marker>
                <!-- <el-amap-info-window :position="markers[0].position">
                                <div>2号线徐泾东地铁站6号口出步行15分钟左右即可到达</div>
                </el-amap-info-window>-->
              </el-amap>
            </div>
            <div class="right">
              <div class="com_name">
                <!-- <img src="../../assets/cont1.png" alt class="cn"> -->
                <p class="cn_p">
                  <span>上海米仑机械设备有限公司</span>
                  <span>SHANGHAI MILLION MACHINERY CO.,LTD.</span>
                </p>
              </div>
              <div class="mail">
                <p>地址： {{addressItem.address}}</p>
                <p>邮箱： {{addressItem.e_mail}}</p>
                <p>电话： {{addressItem.contact_number}} 传真： {{addressItem.fax}}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="btn">
        <router-link to="/" class="content_btn">合作优势</router-link>
      </div>
    </div>
    <div class="modal-backdrop" v-show="showModal" @click="closeModal">
      <div class="modal" id="modal">
        <div class="modal-header">{{titleText || '提示'}}</div>
        <div class="modal-body">
          <p>标注 * 各项均为必填项目</p>
          <input type="text" placeholder="* 您的邮箱地址" v-model="user_Email">
          <input type="text" placeholder="* 贵公司全称" v-model="user_company">
          <input type="text" placeholder="* 您的姓名" v-model="user_name">
          <input type="text" placeholder="* 您的电话或手机号码" v-model="user_phone">
          <div class="select">
            <select
              name="public-choice"
              v-model="provinceSelected"
              class="select_1"
              @change="getProvinceSelected"
            >
              <option value disabled selected style="display:none; color: #ccc">* 省/自治区/直辖市</option>
              <option
                :value="item.value"
                v-for="(item) in provinceData"
                :key="item.key"
              >{{item.value}}</option>
            </select>
            <select name="public-choice" v-model="citySelected" class="select_2">
              <option value disabled selected style="display:none;">* 市/县/区</option>
              <option
                :value="item.value"
                v-for="(item,index) in cityData"
                :key="index"
              >{{item.value}}</option>
            </select>
          </div>
          <input type="text" placeholder="详细街道和门牌号" v-model="user_address">
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-close"
            @click="close"
            v-if="showCancle"
          >{{cancleText?cancleText : '取消'}}</button>
          <button
            type="button"
            class="btn-confirm"
            @click="confirm"
          >{{confirmText ? confirmText : '确定'}}</button>
        </div>
      </div>
    </div>
    <mb-fotter></mb-fotter>
    <div class="banner_img">
      <img src="../../assets/blo6.png" alt>
    </div>
    <div class="banner_img_1">
      <img src="../../assets/blo7.png" alt>
    </div>
  </div>
</template>

<script>
import mbFotter from "../../components/mb-fotter.vue";
import city from "../../utils/city.js";
import request from "../../server/request.js";

export default {
  data() {
    return {
      showCancle: false,
      confirmText: "确认发送",
      showModal: false,
      titleText: "样册索取",
      provinceData: [],
      cityData: [],
      provinceSelected: "",
      citySelected: "",
      user_name: "",
      user_company: "",
      user_phone: "",
      user_Email: "",
      user_address: "",
      center: [121.447611, 31.319122],
      zoom: 16,
      plugin: [
        {
          pName: "ToolBar",
          events: {}
        }
      ],
      componentMarker: {
        position: [121.447611, 31.319122]
      },
      addressItem: ""
    };
  },
  components: {
    mbFotter
  },
  created() {
    if (city) {
      for (const key in city["86"]) {
        if (city["86"].hasOwnProperty.call(city["86"], key)) {
          const element = city["86"][key];
          this.provinceData.push({
            key,
            value: element
          });
        }
      }
    }
    request.getAddress(res => {
      if (res && res.errcode === 0) {
        this.addressItem = res.data[0];
      }
    });
  },
  methods: {
    confirm() {
      if (
        !this.user_phone ||
        !this.user_Email ||
        !this.provinceSelected ||
        !this.citySelected ||
        !this.user_name ||
        !this.user_company
      ) {
        alert("请完善相关信息");
      } else {
        const formData = {
          user_email: this.user_Email,
          user_name: this.user_name,
          user_phone: this.user_phone,
          user_address: this.user_address,
          user_company: this.user_company,
          user_province: this.provinceSelected,
          user_city: this.citySelected
        };
        request.postUserManage(formData, res => {
          if (res && res.errcode === 0) {
            this.showModal = false;
            alert("我们收到了您填写的信息");
          }
        });
      }
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
        }
      }
    },
    getProvinceSelected(e) {
      const currentItem = this.provinceData.filter(
        item => item.value === e.target.value
      )[0];
      if (this.provinceSelected) {
        const value = `${currentItem.key.substring(0, 2)}0000`;
        for (const key in city[value]) {
          if (city[value].hasOwnProperty.call(city[value], key)) {
            const element = city[value][key];
            this.cityData.push({
              key,
              value: element
            });
          }
        }
      }
    }
  }
};
</script>   

<style lang="less" scoped>
.about {
  background: #fff9ed;
  position: relative;
  height: 100%;
  .banner_img {
    position: absolute;
    right: 0;
    bottom: 140px;
  }
  .banner_img_1 {
    position: absolute;
    left: 0;
    bottom: 140px;
  }
  .header {
    .banner {
      width: 100%;
      // height: 12rem;
      background-size: 100% 100%;
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0.26rem 1rem;
      .back {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          margin-right: 5px;
        }
      }
    }
  }
  .body {
    margin-top: -1.2rem;
    width: 100%;
    .body_title {
      padding-left: 10%;
      .body_title_name {
        color: #fff;
        font-size: 0.88rem;
        letter-spacing: 2px;
        margin-right: 0.3rem;
        font-weight: 600;
      }
      .contentus {
        color: #fff;
        font-size: 0.68rem;
        letter-spacing: 2px;
        margin-right: 0.3rem;
        font-weight: 300;
      }
    }
  }
  .main {
    // margin-top: 1rem;
    .main_ul {
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .active {
          margin-top: 0;
          border-top: none;
        }
        .main_h3 {
          width: 80%;
          padding: 0.38rem 0;
          border-top: 1px solid rgba(5, 65, 131);
          border-bottom: 1px solid rgba(5, 65, 131);
          font-size: 0.88rem;
          text-align: center;
          margin-bottom: 0.6rem;
          margin-top: 0;
          font-weight: 800;
          color: rgba(5, 65, 131, 1);
          &.active {
            border-top: none;
          }
        }
        .address {
          display: flex;
          margin-top: 1.08rem;
          .map {
            width: 9rem;
            height: 4.44rem;
            margin-right: 1.5rem;
          }
          .right {
            margin-bottom: 2.3rem;
            .com_name {
              display: flex;
              .cn {
                // width: 2.18rem;
                // height: 1.44rem;
                margin-right: 0.3rem;
              }
              .cn_p {
                display: flex;
                flex-direction: column;
                color: #054183;
                font-size: 0.32rem;
                span {
                  margin-bottom: 0.2rem;
                  color: #054183;
                  &:first-child {
                    font-weight: 900;
                    font-size: 0.4rem;
                  }
                }
              }
            }
            .mail {
              position: relative;
              z-index: 10;
              margin-top: 0.4rem;
              color: #054183;
              font-weight: 500;
              font-size: 0.4rem;
              p {
                margin-top: 0.3rem;
              }
            }
          }
        }
        .get_book {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          img {
            // width: 2rem;
            // height: 3rem;
            // margin-left: 35%;
            margin-right: 0.38rem;
          }
          p {
            width: 6rem;
            line-height: 1.8;
            font-size: 0.36rem;
            font-family: SourceHanSansSC;
            font-weight: 400;
            color: rgba(5, 65, 131, 1);
            line-height: 1.5;
          }
          .get_btn {
            margin-left: 0.3rem;
            width: 4rem;
            display: flex;
            flex-direction: column;
            border: 1px solid rgba(5, 65, 131, 1);
            box-shadow: 0px 1px 3px 0px rgba(9, 1, 3, 0.75);
            align-items: center;
            justify-content: center;
            height: 2.06rem;
            border-radius: 8px;
            // box-shadow: 0px 0px 1px 1px rgb(70, 132, 202);
            background: rgba(255, 255, 255, 1);
            cursor: pointer;
            span {
              color: rgba(5, 65, 131, 1);
              font-weight: 400;
              font-size: 0.38rem;
              &:first-child {
                font-size: 0.48rem;
                margin-bottom: 0.1rem;
              }
            }
          }
        }
        .text {
          width: 100%;
          p {
            text-align: center;
            color: rgb(94, 122, 214);
            font-size: 0.3rem;
            &.weight {
              font-weight: 600;
            }
          }
        }
      }
    }
    .btn {
      width: 100%;
      margin-bottom: 1rem;
      margin-top: 0.41rem;
      display: flex;
      justify-content: center;
      .content_btn {
        position: relative;
        z-index: 2;
        width: 6.76rem;
        height: 1.44rem;
        text-align: center;
        line-height: 1.44rem;
        border: 1px solid #ccc;
        background: #054183;
        color: #fff;
        font-weight: 500;
        font-size: 0.64rem;
        // letter-spacing: 2px;
        border-radius: 4px;
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 15px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      background: #fff;
      position: relative;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      width: 500px;
      transform: translate(0, -20%);
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: flex-start;
        padding: 0.3rem 0 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        position: relative;
        padding: 20px;
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          width: 100%;
          text-align: left;
          color: rgb(70, 111, 223);
          margin-left: 20%;
        }
        input {
          width: 80%;
          height: 0.68rem;
          margin-bottom: 0.2rem;
          padding-left: 10px;
          border-radius: 5px;
          border: 1px solid rgb(70, 111, 223);
          color: #999;
          // border: none;
        }
        .select {
          display: flex;
          width: 80%;
          height: 0.68rem;
          border-radius: 5px;
          margin-bottom: 0.3rem;
          .select_1 {
            width: 58%;
            border: 1px solid rgb(70, 111, 223);
            background: #fff;
            color: #999;
            margin-right: 2%;
            cursor: pointer;
          }
          .select_2 {
            width: 40%;
            border: 1px solid rgb(70, 111, 223);
            cursor: pointer;
            color: #999;
            background: #fff;
          }
        }
      }
      .modal-footer {
        border-top: 1px solid #eee;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .btn-close,
        .btn-confirm {
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-size: 0.28rem;
          padding: 0.3rem 15px;
          outline: none;
          width: 100%;
        }
        .btn-close {
          color: #313131;
          background-color: transparent;
        }
        .btn-confirm {
          color: #000;
          /* background-color: #2d8cf0; */
          background-color: transparent;
        }
      }
    }
  }
}
</style>
